module.exports = __webpack_public_path__ + "static/media/chicken3.6d74dab8.jpg";